// TablaObras.jsx
import React, { useState, useEffect, useMemo, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { useLocalStorage } from "../hooks/useLocalStorage";
import {useEstadoApp} from "../context/EstadoAppContext";
import { AuthContext } from '../context/authContext';

// Componente simple de barra de progreso
const ProgressBar = ({ percentage }) => {
    // Clases dinámicas de Tailwind
    const color = percentage > 100 ? 'bg-red-600' : percentage === 100 ? 'bg-green-600' : percentage > 0 ? 'bg-indigo-600' : 'bg-gray-300';
    
    return (
        <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5">
            <div 
                className={`h-2.5 rounded-full ${color}`} 
                style={{ width: `${percentage}%` }}
            ></div>
        </div>
    );
};

const TablaProyectos = ({ data, arrayEditando, handleIsEditing }) => {
    //console.log("TablaProyectos", data); 
    
    const { setItem, removeItem } = useLocalStorage();
    const { user } = useContext(AuthContext)

    const { estadoAppX, cambiarEstadoApp } = useEstadoApp(); // Usamos nuestro custom hook

    const navigate = useNavigate();

    const thClasses = `px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider`;
    const tdClasses = `px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-gray-200`;


    if (!data || data.length === 0) {
        return <p>No hay obras para mostrar con los filtros aplicados.</p>;
    }

    //crear onRowDoubleClick
	const handleRowDoubleClick = (idPartidoObra) => {
		console.log("CHEQUEAR handleRowDoubleClick", idPartidoObra)
		console.log('Navegando a InicioPage con id_partido_obra:', idPartidoObra);

        // Determinar si OTRO usuario está editando este registro.
        // Si es así, entramos en modo SOLO LECTURA (isEditingProyectos="true" en InicioPage).
        // Si nadie más lo edita, entramos en modo edición normal (isEditingProyectos="false").
        const otroEdita = isEditingByOtherUser(idPartidoObra);
        setItem("isEditingProyectos", otroEdita ? true : false);

		setItem("idPartidoObra", idPartidoObra)

		cambiarEstadoApp("edit_desde_pagos", { //ediT
			obra: idPartidoObra,
			origen: 'tramitaciones' 
		});

		navigate(`/inicio`);//, { state: { id_partido_obra: idPartidoObra } }
		//handleIsEditing(isEditing)
	}

    // Función para verificar si una fila está siendo editada
    const isRowBeingEdited = (obraId) => {
        // Si el array está vacío, retornar falso inmediatamente
        /*if (!arrayEditando || arrayEditando.length === 0) {
            return false;
        }*/
		//console.log("arrayEditando", arrayEditando)

        const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];
        // Verificar si la obra está siendo editada por otro usuario
        const isEditing = safeArray.some(objeto => {
            // Verificar que el objeto tenga las propiedades necesarias
            if (!objeto || !objeto.id_edit || !objeto.user_edit || !objeto.status) {
                return false;
            }
            // Limpiamos las comillas dobles de user_edit para la comparación
            const userEditClean = objeto.user_edit.replace(/"/g, '');
            return objeto.id_edit === obraId && objeto.status === 'editando'; //&& userEditClean !== user 
        });
        
        //console.log("IS EDITING", isEditing)
        return isEditing;
        //return arrayEditando[obraId]?.length > 0;
    };

    //funcion para verificar si ademas es 'solo_lectura'
    const isRowBeingReadOnly = (obraId) => {
        // Si el array está vacío, retornar falso inmediatamente
        /*if (!arrayEditando || arrayEditando.length === 0) {
            return false;
        }*/

         // Asegurarse de que arrayEditando sea un array
        const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];
        // Verificar si la obra está siendo editada por otro usuario
        const isReadOnly = safeArray.some(objeto => {
            // Verificar que el objeto tenga las propiedades necesarias
            if (!objeto || !objeto.id_edit || !objeto.user_edit || !objeto.status) {
                return false;
            }
            // Limpiamos las comillas dobles de user_edit para la comparación
            const userEditClean = objeto.user_edit.replace(/"/g, ''); //HACE falta??
            return objeto.id_edit === obraId && userEditClean !== user && objeto.status === 'solo_lectura';
        });
        
        //console.log("IS EDITING", isEditing)
        return isReadOnly;
        //return arrayEditando[obraId]?.length > 0;
    };

    // Verifica si OTRO usuario (distinto al actual) está editando la obra (status 'editando')
    const isEditingByOtherUser = (obraId) => {
        const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];
        return safeArray.some(objeto => {
            if (!objeto || !objeto.id_edit || !objeto.user_edit || !objeto.status) {
                return false;
            }
            const userEditClean = objeto.user_edit.replace(/"/g, '');
            return objeto.id_edit === obraId && objeto.status === 'editando' && userEditClean !== user;
        });
    };

    const getEditingTooltip = (obraId) => {
        try {
            const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];

            //Verificar si hay id_edit con status 'editando' y 'solo_lectura' y devolver el user_edit
            const editando = safeArray.find(item => item && item.id_edit === obraId && item.status === 'editando');
            const soloLectura = safeArray.find(item => item && item.id_edit === obraId && item.status === 'solo_lectura');

            if (editando && soloLectura) {
                return `Editando usuario: ${editando.user_edit} - Solo lectura: ${soloLectura.user_edit}`;
            } else if (soloLectura) {
                return `Solo lectura: ${soloLectura.user_edit}`;
            } else if (editando){
                return `Editando usuario: ${editando.user_edit}`;
            }
           
        } catch (error) {
            console.error('Error en getEditingTooltip:', error);
            return '';
        }
    };
    
    return (
        <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead className="bg-gray-50 dark:bg-gray-800">
                    <tr><th className={thClasses}>ID</th><th className={thClasses}>Exp. Proyecto</th><th className={thClasses}>Exp. Seguimiento (rendición)</th><th className={thClasses}>Organismo Solicitante</th><th className={thClasses}>Nombre de Obra</th><th className={thClasses}>Estado</th><th className={thClasses}>Avance de Obra</th><th className={thClasses}>Avance Financiero</th><th className={thClasses}>Referente político</th></tr>
                </thead>
                <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
                    {data.map((item, index) => {
                        const isEditing = isRowBeingEdited(item.id_partido_obra);
                        const isReadOnly = isRowBeingReadOnly(item.id_partido_obra);
                        const editingTooltip = item.organismo_solicitante;
                        const editingTooltip_EDITANDO = getEditingTooltip(item.id_partido_obra);                   
                        
                        const ultimoPago = item.ultimoPago || { tipo_pago: '', porc_pago: 0 };
                        
                        // Obtener el porcentaje del anticipo (asumimos que está en item.anticipoPorcentaje o lo calculamos)
                        const porcentajeAnticipo = item.anticipoPorcentaje || 
                                                 (item.ultimoPago?.tipo_pago === 'anticipo' ? item.ultimoPago.porc_pago : 0);
                        
                        // Determinar si es un anticipo del 30% o 50%
                        const esAnticipo30 = porcentajeAnticipo <= 30;
                        
                        // Calcular el porcentaje incremental según las reglas
                        let porcentajeIncremental = 0;
                        
                        if (!ultimoPago) {
                            porcentajeIncremental = 0;
                        } else {
                            switch(ultimoPago.tipo_pago) {
                                case 'anticipo':
                                    // Para anticipo, el porcentaje es el mismo que el del anticipo
                                    porcentajeIncremental = ultimoPago.porc_pago;
                                    break;
                                case '2do_pago':
                                    // Si es 2do pago, 65% si el anticipo fue 30%, 100% si fue 50%
                                    porcentajeIncremental = esAnticipo30 ? 65 : 100;
                                    break;
                                case '3er_pago':
                                    // 3er pago solo aplica si el anticipo fue 30%
                                    porcentajeIncremental = esAnticipo30 ? 100 : 0;
                                    break;
                                default:
                                    porcentajeIncremental = ultimoPago.porc_pago || 0;
                            }
                        }

                        //console.log("porcentajeIncremental", porcentajeIncremental);
                        
                        return (
                        <tr key={item.id || index} 
                            //className="hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors duration-150"
                            className={`hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer transition-colors duration-150 ${(isEditing === true && isReadOnly === true)
                                ? 'hover:bg-red-200 bg-red-200 dark:hover:bg-red-200/20 dark:bg-red-200/20 dark:border-l-4 dark:border-l-red-200'
                                : ''
                                } ${(isReadOnly === true && isEditing === false)
                                    ? 'hover:bg-yellow-200 bg-yellow-200 dark:hover:bg-yellow-200/20 dark:bg-yellow-200/20 dark:border-l-4 dark:border-l-yellow-200'
                                    : ''
                                } ${(isEditing === true && isReadOnly === false)
                                    ? 'hover:bg-red-200 bg-red-200 dark:hover:bg-red-200/20 dark:bg-red-200/20 dark:border-l-4 dark:border-l-red-200'
                                    : ''
                                }`}
                            title={editingTooltip_EDITANDO}
                            onDoubleClick={() => handleRowDoubleClick && handleRowDoubleClick(item.id_partido_obra)}>
                            <td className={tdClasses}>{item.id_partido_obra}</td>
                            <td className={tdClasses}>{item.nroExpProyecto}</td>
                            <td className={tdClasses}>{item.nroExpediente}</td>                            
                            {/* ⭐️ CELDA DEL ORGANISMO SOLICITANTE MODIFICADA ⭐️ */}
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div 
                                    className="max-w-xs truncate"
                                    title={editingTooltip}
                                >
                                    {item.organismo_solicitante}
                                </div>
                            </td>
                            {/* ⭐️ FIN DE LA CELDA MODIFICADA ⭐️ */}
                            <td className={tdClasses}>{item.nombre_obra}</td>
                            <td className={tdClasses}>{item.estado}</td>                            
                            {/* ⭐️ CELDA DE AVANCE MODIFICADA ⭐️ */}
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                    <div className="w-full mr-4">
                                        {/* sin Etapa Actual, porque etapa actual hace referencia al pago de la obra y no al avance de la obra */}
                                        <div className="text-sm font-medium text-gray-900 dark:text-white">
                                            {/*{item.etapaActual}*/}
                                        </div>
                                        
                                        <div className="mt-1">
                                            <ProgressBar percentage={item.ultimoPorcentajeObra ? item.ultimoPorcentajeObra : 0} />{/* deberaria ser ---->item.avancePagos. Ahora lo estamos haciendo de obra*/}
                                        </div>
                                    </div>
                                    {/* deberia ser el Porcentaje de pago y no de obra */}
                                    <span className="text-sm font-medium text-gray-500 dark:text-gray-300 w-10 text-right">
                                        {item.ultimoPorcentajeObra ? item.ultimoPorcentajeObra + '%' : '0%'}
                                    </span>
                                </div>
                            </td>
                            {/* ⭐️ FIN CELDA DE AVANCE MODIFICADA ⭐️ */}
                            {/*<td className={tdClasses}>{item.ultimoPago ? item.ultimoPago.tipo_pago : 'Sin Pago'}</td>*/}
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                    <div className="w-full mr-4">
                                        {/* sin Etapa Actual, porque etapa actual hace referencia al pago de la obra y no al avance de la obra */}
                                        <div className="text-sm font-medium text-gray-900 dark:text-white">
                                            {item.ultimoPago ? item.ultimoPago.tipo_pago : 'Sin Pago'}
                                        </div>
                                        
                                        <div className="mt-1">
                                            <ProgressBar percentage={porcentajeIncremental ? porcentajeIncremental : 0} />{/* deberaria ser ---->item.avancePagos. Ahora lo estamos haciendo de obra*/}
                                        </div>
                                    </div>
                                    {/* deberia ser el Porcentaje de pago y no de obra */}
                                    <span className="text-sm font-medium text-gray-500 dark:text-gray-300 w-10 text-right">
                                        {porcentajeIncremental ? porcentajeIncremental + '%' : '0%'}
                                    </span>
                                </div>
                            </td>
                            <td className={tdClasses}>{item.referente_politico_nombre}</td>
                        </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default TablaProyectos;